module.exports = __webpack_public_path__ + "static/media/btn-arrow-expand.31368697.svg";